import React from 'react'

const MarketVIPIcon = props => (
  <div {...props}>
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
        <circle id="path-1" cx="12" cy="12" r="12"/>
      </defs>
      <g id="Asset-Artboard-Page" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="market-VIP-badge">
          <g>
            <g id="path-1-2">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1"/>
              </mask>
              <use id="path-1" fill="#FFCC4E" xlinkHref="#path-1"/>
            </g>
            <polygon id="V" fill="#BE8800" fillRule="nonzero"
                    points="7.9404 15 10.1160001 9.04440022 8.70480003 9.04440022 7.28519998 13.2360001 5.84879993 9.04440022 4.38719988 9.04440022 6.57119996 15"/>
            <polygon id="I" fill="#BE8800" fillRule="nonzero" points="13.1615995 15 13.1615995 9.04440022 11.8175995 9.04440022 11.8175995 15"/>
            <path
              d="M16.6248001,15 L16.6248001,12.8580001 L17.5404001,12.8580001 C18.7500001,12.8580001 19.5816001,12.0768001 19.5816001,10.9512001 C19.5816001,9.84240019 18.7500001,9.04440022 17.5404001,9.04440022 L15.2976002,9.04440022 L15.2976002,15 L16.6248001,15 Z M17.4060002,11.7156002 L16.6332002,11.7156002 L16.6332002,10.1952002 L17.4060002,10.1952002 C17.9100002,10.1952002 18.2544002,10.4808002 18.2544002,10.9596002 C18.2544002,11.4216002 17.9100002,11.7156002 17.4060002,11.7156002 Z"
              id="P" fill="#BE8800" fillRule="nonzero"/>
          </g>
        </g>
      </g>
    </svg>
  </div>
)

export default MarketVIPIcon
